import React, { MouseEventHandler } from "react"
import { Button, Col, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"

const ConfirmModal = ({
    show,
    customer,
    handleClose,
    handleSubmit
}: {
    show: string
    customer: Record<string, any>
    handleClose: () => void
    handleSubmit: Function
}) => {
    const { t, i18n } = useTranslation()

    return (
        <Modal
            show={["creditConfirmModal", "deleteConfirmModal"].includes(show)}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={"gray-bg"}
            centered>
            <Modal.Header className="mx-2" closeButton>
                <Modal.Title>
                    {show === "creditConfirmModal"
                        ? t("Mark / Unmark user as credited.")
                        : t("Delete Customer")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4 mb40 mt-3 py-0">
                <Row className="d-flex align-items-center justify-content-center pt-2 pb-4">
                    <p className="mb-4">
                        {show === "creditConfirmModal" ? (
                            <>
                                {t("Are you sure you want to mark the Selected customer as ")}
                                {!customer?.is_credit_user ? " Credited ?" : " Uncredited ?"}
                            </>
                        ) : (
                            <>{t("Are you sure you want to continue, this cannot be undone!")}</>
                        )}
                    </p>
                    <Col lg={4} className="d-flex align-items-center justify-content-center">
                        <Button
                            variant="secondary"
                            className="w-100"
                            onClick={handleClose as MouseEventHandler<HTMLButtonElement>}>
                            {t("No")}
                        </Button>
                    </Col>
                    <Col lg={4} className="d-flex align-items-center justify-content-center">
                        <Button
                            onClick={() => {
                                if (show === "creditConfirmModal") {
                                    handleSubmit(customer?.id, !customer?.is_credit_user)
                                } else {
                                    handleSubmit(customer?.id)
                                }
                            }}
                            className="btn btn-primary w-100"
                            type="submit">
                            {t("Yes")}
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default ConfirmModal
